// This is being used for the loading spinner on several pages
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["spinner", "content"]

  connect() {
    // Find the closest turbo frame element
    this.turboFrame = this.element.closest("turbo-frame") || this.element.querySelector("turbo-frame")
    
    if (this.turboFrame) {
      this.turboFrame.addEventListener("turbo:frame-load", () => this.hideSpinner())
    }
  }

  showSpinner(event) {
    // Show spinner and hide content
    this.spinnerTarget.classList.remove("hidden")
    this.spinnerTarget.classList.add("flex")
    this.contentTarget.classList.add("hidden")
  }

  hideSpinner() {
    // Hide spinner and show content
    this.spinnerTarget.classList.remove("flex")
    this.spinnerTarget.classList.add("hidden")
    this.contentTarget.classList.remove("hidden")
  }
}
